// extracted by mini-css-extract-plugin
export var addViewLink = "_p-1";
export var availabilityIcon = "_p-16";
export var availabilitySelectionIcon = "_p-15";
export var backButton = "_p-2";
export var backIcon = "_p-z";
export var conversationCount = "_p-3";
export var dragHandle = "_p-5";
export var dropdown = "_p-e";
export var dropdownIcon = "_p-7";
export var dropdownOption = "_p-6";
export var dropdownTriangle = "_p-d";
export var expand = "_p-f";
export var folder = "_p-i";
export var folderItem = "_p-c";
export var icon = "_p-8";
export var iconRow = "_p-9";
export var image = "_p-a";
export var logo = "_p-b";
export var navContainer = "_p-h";
export var navigationFooter = "_p-g";
export var pageShell = "_p-0";
export var placeholderAvailable = "_p-11";
export var placeholderBox = "_p-14";
export var placeholderBusy = "_p-13";
export var placeholderUnavailable = "_p-12";
export var profile = "_p-k";
export var profileContainer = "_p-m";
export var profileDropdown = "_p-n";
export var profileImage = "_p-l";
export var profileMain = "_p-o";
export var profileSubtitle = "_p-q";
export var profileTitle = "_p-p";
export var reorderIcon = "_p-r";
export var sentLine = "_p-u";
export var settingsHeader = "_p-s";
export var sidenavTextColor = "_p-y";
export var spamLine = "_p-t";
export var subitemWithTag = "_p-4";
export var supportItems = "_p-j";
export var teamText = "_p-10";
export var viewLine = "_p-x";
export var viewLineButton = "_p-w";
export var viewLineButtons = "_p-v";